import React from 'react';
import { BiMaleFemale } from 'react-icons/bi';
import { IoMdPricetag } from 'react-icons/io';
import { FaSearch, FaLifeRing } from 'react-icons/fa';
import {
  MdFastfood,
  MdOutlineNightlight,
  MdHotel,
  MdLocationOn,
  MdPublic,
} from 'react-icons/md';

const SearchField = (props) => {
  const LabelIconMap = {
    country: MdPublic,
    nights: MdOutlineNightlight,
    meals: MdFastfood,
    services: FaLifeRing,
    peopleAmount: BiMaleFemale,
    hotels: MdHotel,
    price: IoMdPricetag,
    resort: MdLocationOn,
  };
  // const SelectedIcon = LabelIconMap[props.cssClass] || <FaSearch />;

  const icon = () => {
    if (props.cssClass) {
      const SelectedIcon = LabelIconMap[props.cssClass] || FaSearch;
      return <SelectedIcon className="search-preview-label-icon" />;
    }
    return <FaSearch />;
  };
  return (
    <>
      {icon()}
      {props.placeholder && (
        <div className="search-preview-header">{props.label}</div>
      )}
      <div className="search-preview-data" style={{ position: 'relative' }}>
        {props.title}{' '}
      </div>
    </>
  );
};

export default SearchField;
